import { render, staticRenderFns } from "./NewValidatedInputDemo.vue?vue&type=template&id=b3991b3a&scoped=true&"
import script from "./NewValidatedInputDemo.vue?vue&type=script&setup=true&lang=ts&"
export * from "./NewValidatedInputDemo.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./NewValidatedInputDemo.vue?vue&type=style&index=0&id=b3991b3a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3991b3a",
  null
  
)

export default component.exports